<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                        <h2 class="mb-0">Statement</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <button @click="setData()" type="button" class="btn btn-primary w-100 text-nowrap">Save</button>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <textarea class="form-control" v-model="statement_es" placeholder="Statement Spanish" style="height:300px"></textarea>
                                    <label>Statement Spanish</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <textarea class="form-control" v-model="statement_en" placeholder="Statement English" style="height:300px"></textarea>
                                    <label>Statement English</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import SideBar from '@/components/SideBarNav.vue'
import TopBar from '@/components/TopBarNav.vue'
import axios from 'axios'

export default {
    name: 'StatementAdminComponent',
    components: { SideBar, TopBar },
    data() {
        return {
            statement_es: '',
            statement_en: ''
        }
    },
    created() {
        this.getData()
    },
    methods: {
        // Backend wraps text fields with nl2br on GET, so strip the <br/> tags
        // before binding to the textarea to avoid showing them as literal text.
        stripBr(s) {
            return (s || '').replace(/<br\s*\/?>/gi, '')
        },
        getData() {
            axios.get(this.$url + '/artist', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            }).then((res) => {
                this.statement_es = this.stripBr(res.data.statement_es)
                this.statement_en = this.stripBr(res.data.statement_en)
            })
        },
        setData() {
            axios.post(this.$url + '/artist', {
                statement_es: this.statement_es,
                statement_en: this.statement_en
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            }).then(() => {
                this.$notify({
                    group: 'iasc',
                    title: 'Saved',
                    text: 'Statement updated',
                    type: 'success'
                })
            }).catch(() => {
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: 'Could not save statement',
                    type: 'danger'
                })
            })
        }
    }
}
</script>
